import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.fh_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
        this.gh_1 = new RegExp('[\\\\$]', 'g');
        this.hh_1 = new RegExp('\\$', 'g');
      }
      ih(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.fh_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '\\$&');
      }
      jh(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.hh_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '$$$$');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1fl88t9y3475r,
};
//endregion

//# sourceMappingURL=regex.mjs.map
